import IMask from "imask";

export default class PaymentLink {
  constructor() {
    if(this.isOrderPayPage()) {
      this.handlePersonType();
      this.handleDocumentMask();
      this.validateFormFields();
      this.fillFormFields();
    }
  }

  handlePersonType() {
    const personType = document.querySelector('#billing_persontype');

    if (personType) {
      this.selectPersonType();

      personType.addEventListener('change', () => {
        this.selectPersonType();
      })
    }
  }

  selectPersonType() {
    const personType = document.querySelector('#billing_persontype');
    const cpf = document.querySelector('#billing_cpf_field');
    const cnpj = document.querySelector('#billing_cnpj_field');
    const company = document.querySelector('#billing_company_field');

    if (personType.value === '1') {
      cpf.style.display = 'block';

      cnpj.style.display = 'none';
      company.style.display = 'none';
    }

    if (personType.value === '2') {
      cpf.style.display = 'none';

      cnpj.style.display = 'block';
      company.style.display = 'block';
    }
  }

  isOrderPayPage() {
    const url = new URLSearchParams(location.href);
    if (url.has("vindi-payment-link")) {
      return true;
    }

    return false;
  }

  handleDocumentMask() {
    const cpf = document.querySelector('#billing_cpf');
    const cnpj = document.querySelector('#billing_cnpj');
    const phone = document.querySelector('#billing_phone');

    if (cpf) {
      IMask(cpf, {
        mask: "000.000.000-00",
      });
    }

    if (cnpj) {
      IMask(cnpj, {
        mask: "00.000.000/0000-00",
      });
    }

    if (phone) {
      IMask(phone, {
        mask: "(00) 0 0000-0000",
      });
    }
  }

  validateFormFields() {
    const form = document.querySelector('.woocommerce > #order_review');

    if (form) {
      this.setRequiredAttribute();

      form.addEventListener('submit', (e) => {
        e.preventDefault();

        this.saveFormData();

        if (!form.reportValidity()) {
          setTimeout(() => {
            this.handleWoocommerceLoader(false);
          }, 500);

          return;
        }

        this.handleWoocommerceLoader(true);
        form.submit();
      });
    }
  }

  handleWoocommerceLoader(active = true) {
    const loaders = document.querySelectorAll('.blockUI');

    loaders.forEach(loader => {
      loader.style.display = 'block';

      if (!active) {
        loader.style.display = 'none';
      }
    });
  }

  setRequiredAttribute() {
    const fields = this.getFormFields(true);

    fields.forEach(field => {
      const element = document.querySelector(`#billing_${field}`);
      if (element) {
        element.setAttribute('required', true);
      }
    });
  }

  getFormFields(requiredOnly = false) {
    let requiredFields = ['first_name', 'last_name', 'person_type', 'country', 'postcode', 'address_1', 'neighborhood', 'number', 'city', 'phone', 'email'];

    if (requiredOnly) {
      return requiredFields;
    }

    return requiredFields.concat(['address_2', 'cpf', 'cnpj']);
  }

  saveFormData() {
    const fields = this.getFormFields();
    const formData = {};

    fields.forEach(field => {
      const element = document.querySelector(`#billing_${field}`);
      if (element) {
        formData[field] = element.value;
      }
    });

    localStorage.setItem('vindi-pagamento-form-data', JSON.stringify(formData));
  }

  fillFormFields() {
    const formData = localStorage.getItem('vindi-pagamento-form-data');

    if (formData) {
      const formDataObject = JSON.parse(formData);

      for (const key in formDataObject) {
        if (Object.prototype.hasOwnProperty.call(formDataObject, key)) {
          const element = document.querySelector(`#billing_${key}`);
          if (element) {
            element.value = formDataObject[key];
          }
        }
      }
    }
  }
}
